import React from 'react';
import keyValue from './KeyValueType';
import './style.scss';
export default function KeyValue(props: keyValue) {
	console.log('props', props);

	return (
		<div className='key-value-container'>
			<h6>{props.keyName}</h6>
			<p>{props.value}</p>
		</div>
	);
}
